import React from 'react'
import { InputAddressAutocomplete } from '.'
import type { InputAddressAutocompleteProps } from './type'

export const InputAddressAutocompleteDesktop = (
    props: InputAddressAutocompleteProps
) => {
    return (
        <InputAddressAutocomplete
            placeholder={'storelocator.search.placeholder.desktop'}
            height={5}
            textSize={18}
            radius={10}
            {...props}
        />
    )
}
